import { Injectable, OnDestroy } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable, Subject, Subscription, throwError } from "rxjs";
import { CustomHttpClientService } from "./custom-http-client.service";
import { catchError } from "rxjs/operators";
import { HttpHeaders } from "@angular/common/http";
declare var $: any;
@Injectable()
export class GroupService implements OnDestroy {
  private data: Object;
  private url = environment.apiUrl;
  private _group$: Subject<{}>;
  private timer;
  private sub: Subscription;
  token = localStorage.getItem("token");

  constructor(private http: CustomHttpClientService) {
    this.token = localStorage.getItem("token");
    this._group$ = <Subject<{}>>new Subject();

    // Initialize socket connection similar to feed service
    $(document).ready(() => {
      setTimeout(() => {
        this.initializeSocketConnection();
      }, 500);
    });
  }

  private initializeSocketConnection() {
    try {
      if (self["io"] && self["io"].socket) {
        this.defaultGroupInfo();
        this.setupSocketEventListeners();
        this.handleSocketReconnection();
      }
    } catch (error) {
      console.error("Error initializing group socket connection:", error);
      // Retry connection after delay
      setTimeout(() => {
        this.initializeSocketConnection();
      }, 3000);
    }
  }

  private setupSocketEventListeners() {
    // Remove existing listeners to prevent duplicates
    self["io"].socket.off("groupcontroller");
    self["io"].socket.off("allgroups");
    self["io"].socket.off("allresidentsgroups");
    self["io"].socket.off("getAllGroupMsgCount");
    self["io"].socket.off("groupmessage");
    self["io"].socket.off("groupupdate");
    self["io"].socket.off("connected"); // Also remove the old connected event

    // Set up event listeners
    self["io"].socket.on("groupcontroller", (data) => {
      this._group$.next(data);
    });

    self["io"].socket.on("allgroups", (data) => {
      this._group$.next(data);
    });

    self["io"].socket.on("allresidentsgroups", (data) => {
      this._group$.next(data);
    });

    self["io"].socket.on("getAllGroupMsgCount", (data) => {
      // This is for message counts, components expect getAllPrivateGroupMsgCount
      this._group$.next({
        getAllGroupMsgCount: data.getAllGroupMsgCount,
        getAllPrivateGroupMsgCount: data.getAllPrivateGroupMsgCount,
        buildingsFilter: data.buildingsFilter
      });
    });

    self["io"].socket.on("groupmessage", (data) => {
      // This is for chat messages - components expect message["message"]
      this._group$.next(data);
    });

    self["io"].socket.on("groupupdate", (data) => {
      this._group$.next(data);
    });

    // Keep the old "connected" event for backwards compatibility
    self["io"].socket.on("connected", (data) => {
      this._group$.next(data);
    });
  }

  private handleSocketReconnection() {
    self["io"].socket.on("disconnect", () => {
      setTimeout(() => {
        this.initializeSocketConnection();
      }, 3000);
    });
  }

  get group$() {
    return this._group$.asObservable();
  }

  createGroup(groupFormValue: any): Observable<any> {
    return this.http.post<any>(this.url + "group/create", groupFormValue);
  }

  // For My Groups tab - get user's groups
  getMyGroups() {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for getMyGroups");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error("No authentication token available for getMyGroups");
        return;
      }

      self["io"].socket.get(
        "/group",
        {
          extraHeaders: {
            authorization: this.token,
          },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error fetching my groups:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in getMyGroups:", error);
    }
  }

  // For All Groups tab - get all building groups
  getAllResidentsGroups() {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for getAllResidentsGroups");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error("No authentication token available for getAllResidentsGroups");
        return;
      }

      self["io"].socket.get(
        "/group/allResidentsGroups",
        {
          extraHeaders: {
            authorization: this.token,
          },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error fetching all residents groups:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in getAllResidentsGroups:", error);
    }  
  }

  // For Messages tab - get private groups and message counts
  getPrivateGroupsAndCounts() {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for getPrivateGroupsAndCounts");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error("No authentication token available for getPrivateGroupsAndCounts");
        return;
      }

      
      // Get user's groups (will be filtered for private ones in component)
      self["io"].socket.get(
        "/group",
        {
          extraHeaders: {
            authorization: this.token,
          },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error fetching private groups:", response.error);
          }
        }
      );

      // Get message counts
      self["io"].socket.get(
        "/group/getAllGroupMsgCount",
        {
          extraHeaders: {
            authorization: this.token,
          },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error fetching group message counts:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in getPrivateGroupsAndCounts:", error);
    }
  }

  // Legacy method for backward compatibility
  defaultGroupInfo() {
    // This method was being called by all components
    // Now we'll call the appropriate method based on context
    this.getMyGroups();
  }

  checkUsersGroups() {
    //Get all users
    //self["io"].socket.get('/group');
  }

  sendMessage(submission: { message: string }) {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for sending message");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error("No authentication token available for sending message");
        return;
      }

      // Emit the message along with the token as part of the payload
      self["io"].socket.get(
        "/group/sendGroupMsg",
        {
          message: submission["message"],
          extraHeaders: { authorization: this.token },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error sending group message:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in sendMessage:", error);
    }
  }

  sendGroupMessage(submission: {}) {
    // Emit the group message along with the token as part of the payload
    self["io"].socket.get("/group/sendGroupMsg", {
      message: submission["message"],
      extraHeaders: { authorization: this.token },
    });
  }

  sendChatMessageWithFile(submission: any): Observable<any> {
    const formData: FormData = new FormData();
    
    const messagePayload = {
      to: submission["message"].to,
      groupId: submission["message"].groupId,
      caption: submission["message"].caption,
      page: submission["message"].page,
    };
    
    const messageContent = JSON.stringify(messagePayload);

    formData.append("message", messageContent);
    if (submission["file"]) {
      formData.append("groupImage", submission["file"]);
    }

    return this.http
      .post<any>(`${this.url}group/sendGroupImage`, formData)
      .pipe(catchError(this.handleError));
  }

  //   joinPrivate(group) {
  //       self["io"].socket.get('/group/joinPrivate', {
  //           groupId : group.id, page : group.page,
  //           extraHeaders: {authorization: this.token} });
  //   }

  joinPrivate(group: { id: string; page: number }) {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for joining private group");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error(
          "No authentication token available for joining private group"
        );
        return;
      }

      // Emit the joinPrivate event along with group ID, page, and token
      self["io"].socket.get(
        "/group/joinPrivate",
        {
          groupId: group.id,
          page: group.page,
          extraHeaders: { authorization: this.token },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error joining private group:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in joinPrivate:", error);
    }
  }
  //   leavePrivate(joinUserId) {
  //       self["io"].socket.get('/group/leavePrivate', {extraHeaders: {authorization: this.token}});
  //       this._group$.next({
  //           message: "You are left Chat Room"
  //       });
  //   }

  leavePrivate(joinUserId: any) {
    // Emit the leavePrivate event along with the token and any other data
    self["io"].socket.get("/group/leavePrivate", {
      extraHeaders: { authorization: this.token },
    });
    this._group$.next({
      message: "You are left Chat Room",
    });

    // Notify the application state that the user has left the chat room
    this._group$.next({ message: "You have left the Chat Room" });
  }

  getUserBuildingsInfo(): Observable<any> {
    return this.http.post<any>(this.url + "group/getUserBuildingsInfo", "");
  }

  joinGroup(groupId: any): Observable<any> {
    return this.http.post<any>(this.url + "group/joinGroup", groupId);
  }

  leaveGroup(groupId: any): Observable<any> {
    return this.http.post<any>(this.url + "group/leaveGroup", groupId);
  }

  deleteGroup(id: any): Observable<any> {
    return this.http.delete<any>(this.url + "group/deleteGroup/" + id);
  }

  getAllGroups(): Observable<any> {
    return this.http.get<any>(this.url + "group/getAllGroups");
  }

  updateMsgStatus(groupId: string): void {
    try {
      if (!self["io"] || !self["io"].socket) {
        console.error("Socket not available for updating message status");
        return;
      }

      // Get updated token
      this.token = localStorage.getItem("token");
      if (!this.token) {
        console.error(
          "No authentication token available for updating message status"
        );
        return;
      }

      // Emit the event with the appropriate data
      self["io"].socket.post(
        "/group/updateMsgStatus",
        {
          groupId: groupId,
          extraHeaders: { authorization: this.token },
        },
        (response) => {
          if (response && response.error) {
            console.error("Error updating message status:", response.error);
          }
        }
      );
    } catch (error) {
      console.error("Error in updateMsgStatus:", error);
    }
  }

  getGroups(): Observable<any> {
    return this.http.get<any>(this.url + "group/getNonUserGroups");
  }

  private handleError(error: any): Observable<never> {
    console.error("An error occurred:", error);
    return throwError(error); // Return observable with error
  }

  ngOnDestroy() {
    // Clean up socket event listeners
    if (self["io"] && self["io"].socket) {
      self["io"].socket.off("groupcontroller");
      self["io"].socket.off("allgroups");
      self["io"].socket.off("allresidentsgroups");
      self["io"].socket.off("getAllGroupMsgCount");
      self["io"].socket.off("groupmessage");
      self["io"].socket.off("groupupdate");
      self["io"].socket.off("connected");
      self["io"].socket.off("disconnect");
    }

    // Clean up subscriptions
    if (this.sub) {
      this.sub.unsubscribe();
    }

    // Complete the subject
    if (this._group$) {
      this._group$.complete();
    }
  }
}
